import { createSortOption } from "@nosto/preact"
export const sizes = [30, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("revenue", "Best Selling", { field: "stats.revenue", order: "desc" }),
    createSortOption("-rating", "Top Rated", { field: "reviewCount", order: "desc" }),
    createSortOption("price", "Price ($ - $$$)", { field: "price", order: "asc" }),
    createSortOption("-price", "Price ($$$ - $)", { field: "price", order: "desc" }),
    createSortOption("date", "Newest", { field: "datePublished", order: "desc" })
]

export const defaultConfig = {
    sort: [sortOptions[1]],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

/* ================================ FACETS / FILTERS ================================ */

/* values to use when selecting a product variant, if filter is toggled */
export const variantFilterMatch = [
    { 
        filterField: "extra.polywood color", 
        skuCustomFieldKey: "polywood color" 
    },
    {
        filterField: "skus.customFields.metafields-finish_category", 
        skuCustomFieldKey: "metafields-finish_category" 
    },
    {
        filterField: "skus.customFields.sort-display_variant", 
        skuCustomFieldKey: "sort-display_variant" 
    }
]

/* reorder values */
export const filterOrder = {
    "Seat Capacity": [
        "1 Person", "2 People", "3 People", "4 People", "5 People", "6 People", "7 People", "8 People", "9 People", "10 People", "11 People"
    ],
}

/* native popular filters */
export const nativePopularFilters = Array.from(document.querySelectorAll('form[sub-section-id="popular-filters-facets-form"] summary > div > span:first-child')).map(el => el.textContent);
window.popularFilters = nativePopularFilters;

export const colorFacetGroups = [
    {
        name: "POLYWOOD Heritage™",
        titleBg: 'https://www.polywood.com/cdn/shop/files/o9jfkeoratzivclvtfvm_295a0a7c-0407-471c-ad81-7fb04d98b95f.jpg?v=1736173462&width=100',
        desc: "The original all-weather plastic lumber featuring the POLYWOOD Signature™ finish",
        values: ['Aruba', 'Black', 'Green', 'Lemon', 'Lime', 'Mahogany', 'Navy', 'Pacific Blue', 'Sand', 'Slate Grey', 'Sunset Red', 'Tangerine', 'Teak', 'White'],
    },
    {
        name:  "POLYWOOD Vintage™",
        titleBg: 'https://www.polywood.com/cdn/shop/files/r1fatnvtqsqeevpnuzqn_e1eb13e2-222e-4ef7-9bbf-26e0360caed4.jpg?v=1736173478&width=100',
        desc: "Elevated earth tones featuring the POLYWOOD Wirebrush finish for enduring character",
        values: ['Vintage Coffee', 'Vintage Sahara', 'Vintage White'],

    },
    {
        name: "POLYWOOD Select™",
        titleBg: 'https://www.polywood.com/cdn/shop/files/cqhju1faeuguxiogtyos_ddaa5ef3-4cd5-428f-ac93-fa94595fc48e.jpg?v=1736884316&width=100',
        desc: "Our premium GenuineGrain finish with TrueTone hues for textural depth",
        values: ['Driftwood','Kona','Natural','White / Driftwood']
    },
]

export const colorFacetImages = {
    'Aruba': 'https://www.polywood.com/cdn/shop/files/LUMBER_AR-Aruba_Shopify.jpg?v=1737422102&width=40',
    'Black': 'https://www.polywood.com/cdn/shop/files/LUMBER_BL-Black_Shopify.jpg?v=1737422102&width=40',
    'Green': 'https://www.polywood.com/cdn/shop/files/LUMBER_GR-Green_Shopify.jpg?v=1737422102&width=40',
    'Lemon': 'https://www.polywood.com/cdn/shop/files/LUMBER_LE-Lemon_Shopify.jpg?v=1737422102&width=40',
    'Lime': 'https://www.polywood.com/cdn/shop/files/LUMBER_LI-Lime_Shopify.jpg?v=1737422102&width=40',
    'Mahogany': 'https://www.polywood.com/cdn/shop/files/LUMBER_MA-Mahogany_Shopify.jpg?v=1737422102&width=40',
    'Navy': 'https://www.polywood.com/cdn/shop/files/LUMBER_NV-Navy_Shopify.jpg?v=1737422101&width=40',
    'Pacific Blue': 'https://www.polywood.com/cdn/shop/files/LUMBER_PB-Pacific-Blue_Shopify.jpg?v=1737422102&width=40',
    'Sand': 'https://www.polywood.com/cdn/shop/files/LUMBER_SA-Sand_Shopify.jpg?v=1737422102&width=40',
    'Slate Grey': 'https://www.polywood.com/cdn/shop/files/LUMBER_GY-Slate-Grey_Shopify.jpg?v=1737422102&width=40',
    'Sunset Red': 'https://www.polywood.com/cdn/shop/files/LUMBER_SR-Sunset-Red_Shopify.jpg?v=1737422102&width=40',
    'Tangerine': 'https://www.polywood.com/cdn/shop/files/LUMBER_TA-Tangerine_Shopify.jpg?v=1737422102&width=40',
    'Teak': 'https://www.polywood.com/cdn/shop/files/LUMBER_TE-Teak_Shopify.jpg?v=1737422102&width=40',
    'White': 'https://www.polywood.com/cdn/shop/files/LUMBER_WH-White_Shopify.jpg?v=1737422101&width=40',
    'Vintage Coffee': 'https://www.polywood.com/cdn/shop/files/LUMBER_VCF-Vintage-Coffee_Shopify.jpg?v=1737422102&width=40',
    'Vintage Sahara': 'https://www.polywood.com/cdn/shop/files/LUMBER_VSH-Vintage-Sahara_Shopify.jpg?v=1737422102&width=40',
    'Vintage White': 'https://www.polywood.com/cdn/shop/files/LUMBER_VWH-Vintage-White_Shopify.jpg?v=1737422102&width=40',
    'Driftwood': 'https://www.polywood.com/cdn/shop/files/LUMBER_NDW-Driftwood_Shopify.jpg?v=1737422102&width=40',
    'Kona': 'https://www.polywood.com/cdn/shop/files/LUMBER_NKA-Kona_Shopify.jpg?v=1737422102&width=40',
    'Natural': 'https://www.polywood.com/cdn/shop/files/LUMBER_Natural_Shopify.jpg?v=1737993711',
    'White / Driftwood': '',
}

// use matching facet.name
export const visualFacets = [
    { 
        facetField: "customFields.metafields-marketing_category_tier_1",
        field: "metafields-marketing_category_tier_1", 
        hidden: true 
    },
    { 
        facetField: "customFields.metafields-marketing_category_tier_2",
        field: "metafields-marketing_category_tier_2", 
        hidden: true 
    },
    { 
        facetField: "customFields.metafields-marketing_category_tier_3",
        field: "metafields-marketing_category_tier_3", 
        hidden: true 
    },
    { 
        facetField: "customFields.metafields-seats_x",
        field: "metafields-seats_x", 
        hidden: false 
    }
]

export const tier3Map = {
    "Adirondack Chair": "Adi Chair",
    "Adirondack Connecting Table": "Adi Connecting Tables",
    "Adirondack Head Rest": "Adi Head Rest",
    "Adirondack Ottoman": "Adi Ottoman",
    "Adirondack Set": "Adi Sets",
    "Bar Arm Chair": "Arm Chair - Bar",
    "Bar Side Chair": "Side Chair - Bar",
    "Bench Swing": "Bench Swings",
    "Counter Arm Chair": "Arm Chair - Counter",
    "Counter Side Chair": "Side Chair - Counter",
    "Day Bed Swing": "Day Bed Swings",
    "Deep Seating Chair": "DS Chairs, DS Chairs - Modular Components",
    "Deep Seating Chaise": "DS Chaises - Modular Components",
    "Deep Seating Cushion": "DS Cushion",
    "Deep Seating Loveseat": "DS Loveseats, DS Loveseats - Modular Components",
    "Deep Seating Ottoman": "DS Ottoman",
    "Deep Seating Rocker": "DS Rockers",
    "Deep Seating Set": "DS Sets",
    "Deep Seating Sofa": "DS Sofas, DS Sofas - Sectionals",
    "Deep Seating Swing": "DS Swings",
    "Deep Seating Swivel Chair": "DS Swivels",
    "Dining Arm Chair": "Arm Chair - Dining",
    "Dining Bench": "Bench, Bench - Dining",
    "Dining Side Chair": "Side Chair - Dining",
    "Glider Ottoman": "Glider Ottomans",
    "Kids Adirondack Chair": "Kids Adi Chair",
    "Rocking Chair Set": "Rocking Chair Sets"
};

// ON/OFF UI - use facet.name & value.value
export const toggleFacets = [ 
    { facetName: "Quick Ship", valueName: "true" },
    { facetName: "POLYWOOD Select™", valueName: "true" }, 
    { facetName: "On Sale", valueName: "true" },
]

export const lumberFinishFilters = {
    "gid://shopify/Metaobject/97904656611": "Polywood Heritage™",
    "gid://shopify/Metaobject/95885197539": "Polywood Vintage™",
    "gid://shopify/Metaobject/97904722147": "Polywood Select™",
}

/* ================================ SEARCH DROPDOWN ================================ */

export const popularSearches = [
    "Adirondack chair",
    "side table",
    "chaise lounge",
    "rocking chair",
    "bar",
]

/* ================================ recs ================================ */
export const DROPDOWN_RECID = "searchdropdown-nosto-1";
export const DROPDOWN_NORESULTS_RECID = "searchdropdown-nosto-2";
export const NORESULTS_RECID = "noresults-nosto-1";



export const updateFacetsWithFilterTemplate = (currentFacets = null, filterTemplateFacets = null) => {
    if(!filterTemplateFacets) return currentFacets;
    let newFacets = [];
    currentFacets.forEach((filter) => {
        filterTemplateFacets.forEach((templateFilter) => {
            if(templateFilter === filter.name) {
                newFacets.push(filter);
            }
        });
    });

    newFacets.sort((a, b) => {
        const indexA = filterTemplateFacets.indexOf(a.name)
        const indexB = filterTemplateFacets.indexOf(b.name)
        return indexA - indexB
    });

    return newFacets;
};